import { render, staticRenderFns } from "./CompanyCardForm.vue?vue&type=template&id=04f53fac&scoped=true&"
import script from "./CompanyCardForm.vue?vue&type=script&lang=js&"
export * from "./CompanyCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f53fac",
  null
  
)

export default component.exports